import angular from 'angular';
import moment from 'moment';

angular
  .module('cxSettings')
  .controller('UpdateRegistrationsInternalPriceDialogCtrl', [
    '$element',
    '$scope',
    'close',
    '$window',
    'internalPrice',
    'flySvc',
    updateRegistrationsInternalPriceDialogCtrl,
  ]);

function updateRegistrationsInternalPriceDialogCtrl(
  $element,
  $scope,
  close,
  $window,
  internalPrice,
  flySvc,
) {
  var vm = this;
  vm.model = {
    internalPrice,
    updateRegistrations: false,
    startDate: moment()
      .utc()
      .startOf('day')
      .toDate(),
    endDate: moment()
      .utc()
      .startOf('day')
      .toDate(),
  };

  vm.submit = function() {
    if (vm.model.updateRegistrations && (!vm.model.startDate || !vm.model.endDate)) {
      flySvc.error('msgStartEndDateRequiredUpdateInternalPrice');
      return;
    }

    if (vm.model.updateRegistrations) {
      vm.model.startDate = moment.utc(vm.model.startDate);
      vm.model.endDate = moment.utc(vm.model.endDate);
    }

    $element.modal('hide');
    close(vm.model, 500);
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
